import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../api/client.jsx';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';
import { useApiMutation } from '../../api/mutations';
import {
  productsFixture,
  createProductFixture,
  updateProductFixture,
  deleteProductFixture,
} from './fixture';

export function useProducts() {
  const { fetch } = useApiClient();
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['products', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) {
        await fixtureDelay();
        return productsFixture();
      }
      return fetch('/v1/admin/products');
    },
  });
}

export function useCreateProduct() {
  return useApiMutation({
    live: (fetch, body) => fetch('/v1/admin/products', { method: 'POST', body }),
    fixture: (body) => createProductFixture(body),
    invalidate: ['products'],
    successMessage: (res) => `Produkt "${res.product.sku}" angelegt.`,
  });
}

export function useUpdateProduct() {
  return useApiMutation({
    live: (fetch, { id, patch }) =>
      fetch(`/v1/admin/products/${id}`, { method: 'PUT', body: patch }),
    fixture: ({ id, patch }) => updateProductFixture(id, patch),
    invalidate: ['products'],
    successMessage: 'Produkt aktualisiert.',
  });
}

export function useDeactivateProduct() {
  return useApiMutation({
    live: (fetch, { id }) => fetch(`/v1/admin/products/${id}`, { method: 'DELETE' }),
    fixture: ({ id }) => deleteProductFixture(id),
    invalidate: ['products'],
    successMessage: 'Produkt deaktiviert (kein Hard-Delete wegen FK).',
  });
}
